import { useAuth } from "@airborne/react-admin";
import React from "react";
import DashboardPbh from "./Pbh/PbhDashboard/DashboardPbh";
import PbhRequestList from "../RequestOrder/Components/PbhRequestOrderList/PbhRequestList";
import EightWingsList from "../RequestOrder/Components/EightWings/EightWingsList/EightWingsList";
import { Roles } from "../../Enums/Roles";

export const InitialDashboard = props => {
  const { user } = useAuth();

  return user?.isCustomer ? (
    user?.roles?.some(x => x == Roles.EightWings) ? (
      <EightWingsList />
    ) : (
      <DashboardPbh />
    )
  ) : (
    <PbhRequestList />
  );
};

export default InitialDashboard;
